// extracted by mini-css-extract-plugin
export default {"container":"Colors_container__n82zk","wrapper":"Colors_wrapper__O9vkD","color":"Colors_color__Xkpvv"};